import { MainPlayer } from '@stores/krpPlayerStores';

function toggleHotspotSelected({ id, isOn }: { id: string; isOn: boolean }) {
  const player = MainPlayer.get();
  if (!player) return;
  const type = player.getHotspotById(id)?.getExtendData('selectedType');
  if (type === 'text') {
    // TODO 标记类型选中状态
  } else if (type === 'image') {
    player.updateHotspot({
      id,
      showImageBorder: isOn,
    });
  }
}

export default toggleHotspotSelected;
